<template>
  <div>
    <el-row>
      <el-col :span="24">
        <Header></Header>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="4">
        <MenuList></MenuList>
      </el-col>
      <el-col :span="20">
        <div
          style="padding-left: 10px;padding-right: 10px;padding-top: 20px;padding-bottom: 10px; display: flex;justify-content: flex-end;">
          <el-tooltip class="item" effect="dark" content="添加预设名单" placement="bottom">
            <el-button type="primary" @click="showAddUserDialog()">添加名单</el-button>
          </el-tooltip>
        </div>
        <div
          style="padding-left: 10px;padding-right: 10px;padding-top: 20px;padding-bottom: 10px; display: flex;justify-content: center;font-size:18px;">
          预设名单
        </div>
        <div style="padding-left: 10px;padding-right: 10px;">
          <el-table border :data="tableData" stripe style="width: 100%;"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}">
            <el-table-column type="index" label="序号" width="50" header-align="center" align="center">
            </el-table-column>
            <el-table-column label="名单名称">
              <template slot-scope="scope">
                <span style="font-weight: bold;">
                  <div>
                    {{scope.row.group_name}}
                  </div>
                </span>
              </template>

            </el-table-column>



            <el-table-column label="人数" width="80" align="center">
              <template slot-scope="scope">
                <span>
                  {{scope.row.user_count}}
                </span>
              </template>
            </el-table-column>



            <el-table-column prop="create_time" label="创建时间" align="center" width="180">

            </el-table-column>

            <el-table-column label="操作" header-align="center" align="center" width="120">
              <template slot-scope="scope">
                <div class="actionStyle">
                  <div>
                    <el-button @click.native.prevent="viewGroup(scope.$index, tableData)" type="text" size="small">
                      <div>查看</div>
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="editGroup(scope.$index, tableData)" type="text" size="small">
                      <div>修改</div>
                    </el-button>
                  </div>

                  <div>
                    <el-button @click.native.prevent="deleteGroup(scope.$index, tableData)" type="text" size="small">
                      <div>删除</div>
                    </el-button>
                  </div>


                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
    </el-row>

    <!--添加或修改分组-->
    <el-dialog title="预设名单" :close-on-click-modal="false" :visible.sync="editGroupDialogVisible" width="40%">
      <div>
        <div style="">
          <div style="font-size:16px;font-weight: bold;margin-bottom: 5px;">名单名称:</div>
          <div>
            <span style="font-size: 18px;">
              <input v-model="group_name" placeholder="点这里输入名单名称" style="font-size:18px;width: 100%;" /></span>
          </div>
        </div>
        <div style="margin-top: 20px;">
          <div
            style="font-size:16px;font-weight: bold;margin-bottom: 5px;display: flex;justify-content: space-between;">
            <span>人员名单（共{{total_name_count}}人）:</span><span @click="importExcelUsers" style="text-decoration: underline;cursor: pointer;">导入Excel文件中名单</span></div>
          <div>
            <span style="font-size: 18px;">
              <textarea maxlength="-1" rows="8" @input="calcUserCount" v-model="user_name_content"
                placeholder="一行一个姓名,可粘贴其他文件中的姓名.如果姓名之间有空格,逗号等,点击底部'以逗号拆分'等可以格式化名单"
                style="font-size:18px;width: 100%;" /></span>
          </div>
          <div style="display: flex;margin-top: 5px;text-decoration: underline;" @click="splitByBlank">
            <div style="cursor: pointer;" @click="splitByBlank">以空格拆分</div>
            <div style="margin-left: 40px;cursor: pointer;" @click="splitByComma">以逗号拆分</div>
            <div style="margin-left: 40px;cursor: pointer;" @click="splitByPauseSign()">以顿号拆分</div>
          </div>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="saveGroup" type="primary">保存</el-button>
        <el-button @click="editGroupDialogVisible = false">取消</el-button>
      </div>

    </el-dialog>




    <!--添加或修改分组-->
    <el-dialog title="名单详情" :close-on-click-modal="false" :visible.sync="viewGroupDialogVisible" width="40%">
      <div>
        <div style="margin-top: 10px;">
          <div>
            <span style="font-size: 18px;">
              <textarea maxlength="-1" rows="8" v-model="user_name_content" placeholder="一行一个"
                style="font-size:18px;width: 99%;" /></span>
          </div>
        </div>
      </div>

      <div style="display: flex;justify-content: flex-end;margin-top: 20px;">
        <el-button @click="viewGroupDialogVisible = false">取消</el-button>
        <el-button @click="copyContent()" type="primary">复制名单</el-button>
      </div>

    </el-dialog>





  </div>
</template>

<script>
  import MenuList from './menu.vue'
  import Header from './head.vue'

  import '../assets/global.css'

  import Utils from '../utils/utils.js'

  export default {
    components: {
      MenuList,
      Header
    },
    data() {
      return {
        username: '',
        tableData: [],
        editGroupDialogVisible: false,
        group_name: '',
        user_name_content: '',
        viewGroupDialogVisible: false,
        total_name_count: 0,
        edit_group_id: '',










        dialogVisible: false,
        searchResultSettingDialogTableVisible: false,
        position: -1,
        msg: '',
        configurations: [],
        showPosition: false,
        unReadDialogFormVisible: false,

        shownotify: 0,
        successDialogVisible: false,

        downloadExcelDialogVisible: false,
        downloadZipDialogVisible: false,
        sendFormDialogVisible: false,

        current_download_file_name: '',
        selected_form_id: '',
        selected_form_name: '',
        selected_form: '',

        downloadPDFDialogVisible: false,
        howToNextStepDialogVisible: false,

        zip_file_form_id: '',

        howToUseInviteFormDialogVisible: false,
        deleteFormConfirmDialogVisible: false,

        random_num: '',
        tmp_random_num: '',

        current_packed_time: '',
        downloadExistZipDialogVisible: false,

        current_index: '',
        current_rows: '',
        current_pasted_minutes: '',

        is_new_zip_file: '0',

        deleteFormDataConfirmDialogVisible: false,

        shareDocDialogVisible: false,

        testQueryDialogVisible: false,
        qrcode_filename: '',

        emptyFormConfirmDialogVisible: false,

        editFormNameDialogVisible: false,
        selectedFormName: '',

        exportExcelDialogVisible: false,
        export_range: '',
        export_form_id: '',


        editFormCommentDialogVisible: false,
        selectedFormComment: ''


      }
    },
    mounted() {
      this.username = this.$session.get('USERNAME') // 获取session
      // this.loadSetting()
    },
    created() {
      console.log('调用exam_list created')
      this.username = this.$session.get('USERNAME') // 获取session
      // this.username = this.$route.params.username

      // this.username='1KuBxMrJiF4oWU5K2l0gv137dHrFKSy2'
      // this.loadDateList()
      this.loadData()
    },
    methods: {
      loadData() {
        console.log('加载数据')
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_load_user_group_list.jsp'
        this.axios.get(requestUrl, {
            params: {
              equipment: that.username
            }
          }).then(function(response) {
            that.tableData = response.data.user_group_list

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      showAddUserDialog() {
        this.user_name_content = ''
        this.group_name = ''
        this.total_name_count = 0
        this.editGroupDialogVisible = true
      },
      saveGroup() {
        if (Utils.isEmpty(this.group_name)) {
          this.$message.error('请输入名单名称!')
          return
        }
        if (Utils.isEmpty(this.user_name_content)) {
          this.$message.error('请输入人员名单!')
          return
        }

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_save_user_group.jsp'
        this.axios.get(requestUrl, {
            params: {
              equipment: that.username,
              group_name: that.group_name,
              name_str: that.user_name_content,
              group_id: that.edit_group_id

            }
          }).then(function(response) {
            that.loadData()

            load.close()

            that.group_name = ''
            that.user_name_content = ''
            that.edit_group_id = ''

            that.editGroupDialogVisible = false

            that.$message('保存成功')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })

      },
      deleteGroup(index, rows) {
        let that = this
        var group_id = rows[index].id
        this.$confirm('确定要删除此名单吗?', '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          that.deleteGroupAction(group_id)
        }).catch(() => {
          // that.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
        })
      },
      deleteGroupAction(group_id) {

        console.log(group_id)
        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/evaluations/web/_delete_user_group.jsp'
        this.axios.get(requestUrl, {
            params: {
              group_id: group_id,
              equipment: that.username,
            }
          }).then(function(response) {
            that.loadData()

            load.close()


            that.$message.success('删除成功')
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },

      viewGroup(index, rows) {

        let that = this
        var group = rows[index]



        this.user_name_content = group.name_str
        this.viewGroupDialogVisible = true
      },
      editGroup(index, rows) {

        let that = this
        var group = rows[index]

        console.log(group)
        this.edit_group_id = group.id


        this.group_name = group.group_name
        this.user_name_content = group.name_str

        this.calcUserCount()

        this.editGroupDialogVisible = true
      },
      splitByBlank() {
        //全角换成半角
        var tmpNameStr = Utils.changeCase(this.user_name_content, 0)
        // this.batch_column_names=tmpNameStr
        tmpNameStr = tmpNameStr.trim()

        if (Utils.isEmpty(tmpNameStr)) {
          this.$message.error('请输入或粘贴了内容后再拆分!')
          return
        }

        let tmpList = []

        tmpList = tmpNameStr.split(/[\s\n]/)

        // str=str.replace(/'/g, '’')
        // str=str.replace(/"/g, '”')

        var tStr = ''

        for (var i = 0; i < tmpList.length; i++) {
          if (tmpList[i] != '') {
            var str = tmpList[i]
            str = str.trim()
            if (Utils.isEmpty(str)) {
              continue
            }

            if (Utils.isEmpty(tStr)) {
              tStr = str
            } else {
              tStr = tStr + '\n' + str
            }

          }
        }

        this.total_name_count = tmpList.length
        this.user_name_content = tStr

        this.$message.success('拆分完成')

      },
      splitByComma() {
        //全角换成半角
        var tmpNameStr = Utils.changeCase(this.user_name_content, 0)
        tmpNameStr = tmpNameStr.trim()

        if (Utils.isEmpty(tmpNameStr)) {
          this.$message.error('请输入或粘贴了内容后再拆分!')
          return
        }

        let tmpList = []

        tmpList = tmpNameStr.split(/[\,\n]/)

        var tStr = ''

        for (var i = 0; i < tmpList.length; i++) {
          if (tmpList[i] != '') {
            var str = tmpList[i]
            str = str.trim()
            if (Utils.isEmpty(str)) {
              continue
            }

            //单引号和双引号替换
            if (Utils.isEmpty(tStr)) {
              tStr = str
            } else {
              tStr = tStr + '\n' + str
            }
          }
        }

        this.total_name_count = tmpList.length
        this.user_name_content = tStr

        this.$message.success('拆分完成')
      },
      splitByPauseSign() {
        //全角换成半角
        var tmpNameStr = Utils.changeCase(this.user_name_content, 0)
        // this.batch_column_names=tmpNameStr
        tmpNameStr = tmpNameStr.trim()

        if (Utils.isEmpty(tmpNameStr)) {
          this.$message.error('请输入或粘贴了内容后再拆分!')
          return
        }

        let tmpList = []

        tmpList = tmpNameStr.split(/[\、n]/)

        // str=str.replace(/'/g, '’')
        // str=str.replace(/"/g, '”')

        var tStr = ''

        for (var i = 0; i < tmpList.length; i++) {
          if (tmpList[i] != '') {
            var str = tmpList[i]
            str = str.trim()
            if (Utils.isEmpty(str)) {
              continue
            }

            if (Utils.isEmpty(tStr)) {
              tStr = str
            } else {
              tStr = tStr + '\n' + str
            }
          }
        }

        this.total_name_count = tmpList.length
        this.user_name_content = tStr

        this.$message.success('拆分完成')
      },
      calcUserCount() {
        let tmpList = []

        tmpList = this.user_name_content.split(/[\s\n]/)
        this.total_name_count = tmpList.length
      },

      copyContent() {

        var content = this.user_name_content

        this.$copyText(content).then(message => {

          this.$message('名单复制成功')


        }).catch(err => {

          this.$message('名单复制失败')

        })

      },























      indexMethod() {
        this.index++
        return this.index
      },
      convertPaperScore(course, paperScore) {
        if (course === '总分' || course.indexOf('排名') >= 0) {
          return '/'
        } else {
          return paperScore
        }
      },
      convertState: function(row, column) {
        var state = row.state

        if (typeof(state) === 'undefined' || state === 1) {
          return '未发放'
        }

        if (state === 2) {
          return '正在填写'
        }

        if (state === 100) {
          return '已收回'
        }
      },
      convertPages: function(row, column) {
        var inputPages = row.input_pages

        if (typeof(inputPages) === 'undefined' || inputPages === 1) {
          return '1张/人'
        }

        if (inputPages > 1) {
          return '多张/人'
        }
      },

      viewExam(index, rows) {
        // rows.splice(index, 1);

        var examID = rows[index].id
        // var course = rows[index].course
        var exam = rows[index].exam

        console.log('查看成绩单:' + exam)

        this.$router.push({
          name: 'exam_detail',
          params: {
            id: examID,
            // course: course,
            exam: exam
          }
        })
      },
      deleteForm(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.selected_form_id = rows[index].id

        // this.deleteFormConfirmDialogVisible = true

        this.position = index
        this.selected_form_id = rows[index].id

        var state = rows[index].state

        if (state === 2) {
          this.$alert('《' + rows[index].form_name + '》正在填写,如要删除,请先收回表格！', '提示', {

            confirmButtonText: '确定',
            callback: action => {
              this.function()
            }
          })

          return
        }

        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据,删除后已经发放的查询将无法查询，且无法恢复！'
        } else {
          this.msg = '确定要删除《' + rows[index].form_name + '》吗?'
        }

        this.deleteFormConfirmDialogVisible = true

        // this.dialogVisible = true
      },
      emptyForm(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.selected_form_id = rows[index].id

        // this.deleteFormConfirmDialogVisible = true


        if (rows[index].submit_count > 0) {
          this.msg = '"' + rows[index].form_name + '"中有数据,清空后已经发放的查询将无法查询，且无法恢复，但此表的二维码仍然有效！'
        } else {
          this.msg = '确定要清空《' + rows[index].form_name + '》吗?'
        }

        this.emptyFormConfirmDialogVisible = true

        // this.dialogVisible = true
      },
      deleteSelectedForm() {
        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入删除验证码!')
          return
        }

        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('删除验证码不正确,请重新输入!')
        } else {

          this.delFormContentRecord()
        }

        //
      },
      delFormContentRecord() {
        let that = this
        this.deleteFormConfirmDialogVisible = false

        // 调用删除接口
        var requestUrl = '/evaluations/web/_delete_form_data_and_template.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {
            that.tableData.splice(that.position, 1)
            // that.loadDateList()

            that.tmp_random_num = ''

            that.$message.success('删除成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },

      emptySelectedForm() {
        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入清空验证码!')
          return
        }

        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('清空验证码不正确,请重新输入!')
        } else {


          this.emptyFormContentRecord()
        }

        //
      },
      emptyFormContentRecord() {
        let that = this
        this.deleteFormConfirmDialogVisible = false

        // 调用删除接口
        var requestUrl = '/evaluations/web/_empty_query_data.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.tmp_random_num = ''
            that.emptyFormConfirmDialogVisible = false

            that.$message.success('清除成功！')
            that.loadData()
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      editFormName(index, rows) {
        this.position = index
        this.selected_form_id = rows[index].id
        this.selectedFormName = rows[index].form_name
        this.editFormNameDialogVisible = true
      },
      editFormNameSave() {
        if (Utils.isEmpty(this.selectedFormName)) {
          this.$message.error('名称不能为空！')
          return
        }

        let that = this

        // 调用删除接口
        var requestUrl = '/evaluations/web/_update_form_name.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              form_name: that.selectedFormName
            }
          }).then(function(response) {

            that.selectedFormName = ''
            that.selected_form_id = ''
            that.editFormNameDialogVisible = false
            that.loadData()

            that.$message.success('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })


      },
      editFormComment(index, rows) {
        this.position = index
        this.selected_form_id = rows[index].id
        this.selectedFormName = rows[index].form_name
        this.selectedFormComment = rows[index].comment
        this.editFormCommentDialogVisible = true
      },
      editFormCommentSave() {
        let that = this

        // 调用删除接口
        var requestUrl = '/evaluations/web/_update_form_comment.jsp'
        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              form_comment: that.selectedFormComment
            }
          }).then(function(response) {

            that.selectedFormName = ''
            that.selected_form_id = ''
            that.selectedFormComment = ''
            that.editFormCommentDialogVisible = false
            that.loadData()

            that.$message.success('修改成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },

      editExam(index, rows) {
        this.position = index
        this.selectedExamID = rows[index].id
        let that = this

        this.$router.push({
          name: 'exam_edit',
          params: {
            id: that.selectedExamID
          }
        })
      },
      importExcel() {
        // this.$router.push('/import_excel'),
        this.$router.push('/import_data_excel')
      },
      importMutiExcel() {
        this.$router.push('/exam_import_anyfile')
      },
      createNewExam() {
        this.$router.push('/exam_new')
      },

      indexMethods(index) {
        return this.tableData.length - index
      },
      viewUnSearchList(index, rows) {
        let that = this

        this.position = index
        this.selectedExamID = rows[index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 注册接口
        var requestUrl = '/score/web/_get_students_score_list_unsearch.jsp'
        this.axios.get(requestUrl, {
            params: {
              id: that.selectedExamID
            }
          }).then(function(response) {
            that.students = response.data
            that.unReadDialogFormVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)
            load.close()
          })
      },
      closeUnreadDialog() {
        this.unReadDialogFormVisible = false
      },
      filterExams(date) {
        console.log(date)
      },
      selectChanged() {
        console.log(this.filterCondition)
        this.loadData()
      },
      phoneShowSetting() {
        this.searchResultSettingDialogTableVisible = true
      },
      importedNextStep() {
        this.successDialogVisible = true
      },
      exportToFile(index, rows) {
        this.current_packed_time = rows[index].packed_finish_time
        this.current_pasted_minutes = rows[index].pasted_minutes

        this.current_index = index
        this.current_rows = rows

        if (this.current_packed_time !== '') {
          this.showExistZipDialog(index, rows)
        } else {
          this.export(index, rows)
        }

        // let that = this

        // // 开启loading
        // const load = this.$loading({
        //   lock: true,
        //   text: 'Loading',
        //   spinner: 'el-icon-loading',
        //   background: 'rgba(0, 0, 0, 0.7)'
        // })

        // var requestUrl = ''

        // var fileType = rows[index].file_type
        // if (fileType === 'EXCEL') {
        //   requestUrl = '/form/web/_export_to_excel.jsp'
        // } else if (fileType === 'ZIP') {
        //   requestUrl = '/form/web/_export_to_zip.jsp'
        // }

        // this.axios.get(requestUrl, {
        //   params: {
        //     username: that.username,
        //     form_id: formId
        //   }
        // }).then(function(response) {
        //   console.log(response)
        //   var fileName = ''
        //   if (fileType === 'EXCEL') {
        //     fileName = '/form/temp/' + formId + '.xls'
        //     that.downloadExcelDialogVisible = true
        //     that.current_download_file_name = fileName
        //   } else if (fileType === 'ZIP') {
        //     fileName = '/form/temp/' + formId + '.zip'
        //     that.downloadZipDialogVisible = true
        //     // that.current_download_file_name = fileName
        //     // that.current_download_file_name = response.data.download_file_path
        //     that.current_download_file_name = fileName

        //     that.zip_file_form_id = formId
        //   }

        //   load.close()
        // }).catch(function(error) {
        //   console.log(error)
        //   load.close()
        // })
      },
      showExistZipDialog(index, rows) {
        var selected_form_id = rows[this.current_index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_load_export_zip_state.jsp'

        this.axios.get(requestUrl, {
          params: {
            form_id: selected_form_id
          }
        }).then(function(response) {
          console.log(response)
          // var fileName = ''

          that.is_new_zip_file = response.data.is_new_zip

          that.downloadExistZipDialogVisible = true

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      downloadExistZip() {
        this.downloadZipDialogVisible = false
        this.downloadExistZipDialogVisible = false

        var selected_form_id = this.current_rows[this.current_index].id

        var url = '/form/download.jsp?form_id=' + selected_form_id
        // window.open(this.current_download_file_name)
        window.open(url)
      },
      export (index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = ''

        var fileType = rows[index].file_type
        if (fileType === 'EXCEL') {
          requestUrl = '/form/web/_export_to_excel.jsp'
        } else if (fileType === 'ZIP') {
          requestUrl = '/form/web/_export_to_zip.jsp'
        }

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          var fileName = ''
          if (fileType === 'EXCEL') {
            fileName = '/form/temp/' + formId + '.xls'
            that.downloadExcelDialogVisible = true
            that.current_download_file_name = fileName
          } else if (fileType === 'ZIP') {
            fileName = '/form/temp/' + formId + '.zip'
            that.downloadZipDialogVisible = true
            // that.current_download_file_name = fileName
            // that.current_download_file_name = response.data.download_file_path
            that.current_download_file_name = fileName

            that.zip_file_form_id = formId
          }

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      exportToPDF(index, rows) {
        var formId = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        var requestUrl = '/form/web/_export_to_pdf.jsp'

        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)
          that.downloadPDFDialogVisible = true

          that.current_download_file_name = response.data.pdf_filename

          load.close()
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      createNewForm() {},
      downloadExcel() {
        this.downloadExcelDialogVisible = false
        window.open(this.current_download_file_name)
      },
      downloadNewZip() {
        this.downloadZipDialogVisible = false
        this.downloadExistZipDialogVisible = false

        let that = this
        var formId = that.current_rows[that.current_index].id

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        var requestUrl = ''
        requestUrl = '/form/web/_export_to_zip.jsp'
        this.axios.get(requestUrl, {
          params: {
            username: that.username,
            form_id: formId
          }
        }).then(function(response) {
          console.log(response)

          load.close()
          var fileName = ''
          fileName = '/form/temp/' + formId + '.zip'
          that.current_download_file_name = fileName
          var selected_form_id = that.current_rows[that.current_index].id
          var url = '/form/download.jsp?form_id=' + selected_form_id
          // window.open(this.current_download_file_name)
          window.open(url)
        }).catch(function(error) {
          console.log(error)
          load.close()
        })
      },
      downloadPDF() {
        this.downloadPDFDialogVisible = false
        window.open(this.current_download_file_name)
      },
      sendForm(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id


        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用删除接口
        var requestUrl = "/evaluations/phone/qrcode_generator.jsp?form_id=" + this.selected_form_id
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.qrcode_filename = '/evaluations' + response.data.file_name
            // console.log('>>>>>>>>>>>>>>>>',that.qrcode_filename)

            that.sendFormDialogVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })


      },
      browseData(index, rows) {
        // var formId = rows[index].id
        // var url = '/form/web/_browse_form_data.jsp?form_id=' + formId
        // window.open(url)

        var formId = rows[index].id
        var formName = rows[index].form_name

        this.$router.push({
          name: 'browse_all_data',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      exportData(index, rows) {
        this.export_form_id = rows[index].id
        this.selected_form = rows[index]

        this.exportExcelDialogVisible = true


      },
      exportDataAction() {


        let that = this

        // 调用删除接口
        var requestUrl = ''


        if (this.selected_form.form_type == '10') {
          requestUrl = '/evaluations/web/_export_self_single_quota_excel.jsp'
        } else if (this.selected_form.form_type == '20') {
          requestUrl = '/evaluations/web/_export_single_quota_excel.jsp'
        } else if (this.selected_form.form_type == '50') {
          requestUrl = '/evaluations/web/_export_self_single_quota_excel_ex.jsp'
        } else if (this.selected_form.form_type == '60') {
          requestUrl = '/evaluations/web/_export_single_quota_excel_ex_muti.jsp'
        }


        this.axios.get(requestUrl, {
            params: {
              form_id: that.export_form_id,
            }
          }).then(function(response) {

            that.export_form_id = ''
            that.export_range = ''

            console.log(response)

            that.current_download_file_name = '/evaluations' + response.data.file_url

            that.exportExcelDialogVisible = false
            that.downloadExcelDialogVisible = true
            // that.downloadExcel()



          })
          .catch(function(error) {
            console.log(error)
          })
      },

      openMakeForm() {
        this.$router.push('/make_form')
      },
      validCondition(index, rows) {
        var formId = rows[index].id
        var formName = rows[index].form_name

        // console.log(rows[index])
        // console.log(formId)
        // console.log(formName)

        this.$router.push({
          name: 'set_valid_condition',
          params: {
            form_id: formId,
            form_name: formName
          }
        })
      },
      whatIsNextStep() {
        this.howToNextStepDialogVisible = true
      },
      collectAdvice(index, rows) {
        // this.$message.info('adsfadf')
      },
      howToUseInviteForm() {
        this.howToUseInviteFormDialogVisible = true
      },
      emptyFormData(index, rows) {
        this.random_num = Utils.getRandomNum(4)
        this.tmp_random_num = ''
        this.msg = '要清空《' + rows[index].form_name + '》的全部数据吗?'
        this.selected_form_id = rows[index].id
        this.deleteFormDataConfirmDialogVisible = true
      },
      emptySelectedFormData() {
        let that = this

        if (Utils.isEmpty(this.tmp_random_num)) {
          this.$message.error('请输入清空数据验证码!')
          return
        }

        if (this.tmp_random_num !== this.random_num) {
          this.$message.error('清空数据验证码不正确,请重新输入!')
          return
        }

        // 调用删除接口
        var requestUrl = '/form/web/_empty_form_data.jsp'
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {
            that.deleteFormDataConfirmDialogVisible = false
            that.tmp_random_num = ''
            // that.tableData.splice(that.position, 1)
            that.loadData()

            that.$message.success('清空成功！')
          })
          .catch(function(error) {
            console.log(error)
          })
      },
      showShareDocDialog() {
        this.shareDocDialogVisible = true
      },
      getSearchedPercent(total, searched_count) {
        var percent = 0;

        if (total == 0) {
          percent = 0
        } else {
          // if(Utils.isEmpty(searched_count)){
          // 	searched_count=1
          // }
          percent = ((searched_count / total) * 100)
        }

        return percent.toFixed(1)
      },
      resetQueryConditions(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id

        this.$router.push({
          name: 'reset_query_conditions',
          params: {
            form_id: this.selected_form_id,
            form_name: this.selected_form_name
          }
        })
      },
      testQuery(index, rows) {
        this.selected_form_name = rows[index].form_name
        this.selected_form_id = rows[index].id

        let that = this

        // 开启loading
        const load = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })

        // 调用删除接口
        var requestUrl = "/evaluations/phone/qrcode_generator.jsp?form_id=" + this.selected_form_id
        console.log('requestUrl =', requestUrl)

        this.axios.get(requestUrl, {
            params: {
              form_id: that.selected_form_id,
              equipment: that.username
            }
          }).then(function(response) {

            that.qrcode_filename = '/evaluations' + response.data.file_name
            // console.log('>>>>>>>>>>>>>>>>',that.qrcode_filename)

            that.testQueryDialogVisible = true

            load.close()
          })
          .catch(function(error) {
            console.log(error)

            load.close()
          })


      },
      copyDownloadUrl() {

        var urlstr = window.location.origin + this.current_download_file_name

        this.$copyText(urlstr).then(message => {

          this.$message('下载网址复制成功')


        }).catch(err => {

          this.$message('下载网址复制失败')

        })

      },
      importExcelUsers() {
        this.$alert('打开Excel文件，复制姓名列，直接粘贴到下面的框中即可。', '导入Excel中的姓名', {
          confirmButtonText: '知道了',
          callback: action => {}
        });
      }
    },
    watch: {
      $route() {
        this.loadData()
      }
    }
  }
</script>

<style>
  .actionStyle {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

  }

  :header-cell-style: {
    background: '#E9EEF5';
    color: '#000'
  }

  .actionBarStyle {
    display: flex;
    justify-content: space-between;
  }

  .rowStyle {
    display: flex;
    justify-content: space-between;
  }

  .settingGroupStyle {
    display: flex;
    flex-direction: column;
  }

  .rowBtnStyle {
    display: flex;
    justify-content: flex-end;
    padding-top: 50upx;
  }

  .dateRowStyle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .imgItemStyle {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .imageStyle {
    display: flex;
    justify-content: center;

  }
</style>



// WEBPACK FOOTER //
// src/components/prepared_user_list.vue